import axios from "axios";

function getCommonConfig(context) {
    let headers = {}
    let jwt = localStorage['em_sso_token']
    // if (context.rootState.auth.token) {
    //     headers['Authorization'] = 'Bearer ' + context.rootState.auth.token
    // }
    if (jwt != null) {
        headers['Authorization'] = jwt
        // console.log("set Authorization to headers")
        // console.log(jwt)
    }
    return {
        headers: headers
    }
}

const state = {};
const getters = {};
const actions = {
    get(context, {url, commonErrorHandle = true, originResponse = false}) {
        return new Promise((resolve, reject) => {
            console.log("api/get 调用")
            console.log(url)
            axios.get(url, getCommonConfig(context))
                .then(response => resolve(originResponse ? response : response.data))
                .catch(error => {
                    commonErrorHandle && context.dispatch("error", {error});
                    return reject(error)
                });
        });
    },
    getTemplateDownload(context, {url, fileName}) {
        return new Promise((resolve, reject) => {
            axios.get(url, {...getCommonConfig(context), responseType: 'blob'})
                .then(response => {
                    var downloadUrl = window.URL.createObjectURL(response.data);
                    var a = document.createElement('a');
                    a.style.display = 'none'
                    a.href = downloadUrl;
                    a.download = [fileName];
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(downloadUrl);
                })
                .catch(error => {
                    context.dispatch("error", {error});
                    reject(error)
                });
        });
    },
    delete(context, {url, commonErrorHandle = true}) {
        console.log("api/delete 调用")
        console.log(url)
        return new Promise((resolve, reject) => {
            axios.delete(url, getCommonConfig(context))
                .then(response => resolve(response.data))
                .catch(error => {
                    commonErrorHandle && context.dispatch("error", {error})
                    return reject(error)
                });
        });
    },
    post(context, {url, data, commonErrorHandle = true, consoleLog = true}) {
        if (consoleLog) {
            console.log("api/post 调用");
            console.log(url)
            console.log(data)
        }
        return new Promise((resolve, reject) => {
            axios.post(url, data, getCommonConfig(context))
                .then(response => resolve(response))
                .catch(error => {
                    commonErrorHandle && context.dispatch("error", {error});
                    return reject(error)
                });
        });
    },
    postMultipart(context, {url, data}) {
        let config = getCommonConfig(context)
        config.headers['Content-Type'] = 'multipart/form-data'
        return new Promise((resolve, reject) => {
            axios.post(url, data, config)
                .then(response => resolve(response))
                .catch(error => {
                    context.dispatch("error", {error});
                    return reject(error);
                });
        });
    },
    postReportDownload(context, {url, data}) {
        return new Promise(resolve => {
            axios.post(url, data, {
                ...getCommonConfig(context),
                responseType: 'blob'
            })
                .then(response => resolve(response.data))
                .catch(error => context.dispatch("error", {error}));
        });
    },
    postNewPageDownload(context, {url, data}) {
        return new Promise((resolve, reject) => {
            axios.post(url, data, {
                ...getCommonConfig(context),
                responseType: 'blob'
            })
                .then(response => {
                    var data = response.data;
                    var fileName = response.headers['download-filename']

                    if (!data || data.size == 0) {
                        context.dispatch("base/showDanger", {
                            userAlertDangerStr: "No report with this fields",
                            userAlertDangerVisible: false,
                        }, {root: true})
                        return;
                    }

                    var blob = new Blob([data]);
                    var link = document.createElement('a');
                    link.style.display = 'none'
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                    link.remove();
                })
                .catch(reject);
        });
    },
    put(context, {url, entity, module, commonErrorHandle = true}) {
        //如果要保存的内容为空，就直接跳回module的list
        if (!entity) {
            return context.dispatch("base/MMFbackToList", module, {root: true})
        }
        //否则就执行保存，保存时使用了完整的url，就不受module限制了
        return new Promise((resolve, reject) => {
            axios.put(url, entity, getCommonConfig(context))
                .then(response => resolve(response.data))
                .catch(error => {
                    console.log(error);
                    commonErrorHandle && context.dispatch("error", {error});
                    return reject(error)
                });
        });
    },
    testWSEndPoint() {
        let xmls = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ws="https://siemens.com/ws">'
        xmls += '   <soapenv:Header/>';
        xmls += '   <soapenv:Body>';
        xmls += '      <ws:IntegrationMessageSaveResponse>';
        xmls += '         <ws:saveResponse>1</ws:saveResponse>';
        xmls += '      </ws:IntegrationMessageSaveResponse>';
        xmls += '   </soapenv:Body>';
        xmls += '</soapenv:Envelope>';

        return new Promise(resolve => {
            axios.post('http://localhost:6662/adm-service/ws/messageWsdl.wsdl?wsdl',
                xmls,
                {
                    headers: {'Content-Type': 'text/xml'}
                }).then(res => {
                resolve(res)
                console.log(res);
            }).catch(err => {
                console.log(err)
            });
        });
    },
    error(context, {error}) {
        console.log("进入api.error了")
        var hideNoAuthMessage = localStorage['hideNoAuthMessage'];
        var userLastVisitedUrl = window.location.href;
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
        } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
        }
        switch (error.request.status) {
            case 0:
                context.dispatch("base/showAlert", {
                    modalTitle: "lbl.basic.no.permission.title",
                    modalHeader: error.message,
                    modalContent: error,
                }, {root: true});
                break;
            case 500:
                if (error.response) {
                    if (error.response.data.status === 4003) {
                        //4003和后端的约定：登录信息过期，就清除掉localStorage内容，并跳转到登录页面
                        localStorage.removeItem('em_sso_token')
                        //同时清除em的用户权限缓存
                        localStorage.removeItem('em_userAclsAndRoles')
                        window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL;
                    } else {
                        context.dispatch("base/showAlert", {
                            modalTitle: error.message,
                            modalHeader: error.response.data.code,
                            modalContent: error.response.data.message,
                        }, {root: true});
                    }
                } else {
                    context.dispatch("base/showAlert", {
                        modalTitle: error.message,
                        modalHeader: error.message,
                        modalContent: error,
                    }, {root: true});
                }
                break;
            case 400:
                context.dispatch("base/showWarning", {
                    userAlertWarningStr: error.request.getResponseHeader("mmfwarning"),
                    userAlertWarningVisible: true,
                }, {root: true});
                break;
            case 401:
                if (!hideNoAuthMessage) {
                    localStorage['hideNoAuthMessage'] = true
                    alert("没有访问权限，如需要访问，请联系管理员");
                    window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL
                }
                break;
            case 403:
                context.dispatch("base/showAlert", {
                    // modalTitle: "Permission error",
                    // modalHeader: "dont have permission to access the resource",
                    //如需配置国际化,需要在App.vue中改动modalTitle和modalHeader取值方式并且在此处传入国际化的key
                    modalTitle: "lbl.basic.no.permission.title",
                    modalHeader: "lbl.basic.no.permission.body",
                    modalContent: error,
                }, {root: true});
                break;
            case 404:
                context.dispatch("base/showAlert", {
                    modalTitle: "Connection error!",
                    modalHeader: error.message,
                    modalContent: error,
                }, {root: true});
                break;
            case 429:
                if (!hideNoAuthMessage) {
                    localStorage['hideNoAuthMessage'] = true
                    localStorage.removeItem('em_sso_token')
                    localStorage['return_url'] = userLastVisitedUrl
                    this._vm.$alert('您的帐号在其他位置登陆，您被迫下线，有问题请及时联系管理人员', '操作提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: () => {
                            window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL
                        }
                    })
                }
                break;
            case 498:
                if (!hideNoAuthMessage) {
                    localStorage['hideNoAuthMessage'] = true
                    localStorage.removeItem('em_sso_token')
                    localStorage['return_url'] = userLastVisitedUrl
                    alert("登录超时，请重新登录");
                    window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL
                }
                break;
            case 4060:
                if (!hideNoAuthMessage) {
                    localStorage['hideNoAuthMessage'] = true
                    localStorage.removeItem('em_sso_token')
                    localStorage['return_url'] = userLastVisitedUrl
                    this._vm.$alert('抱歉，您的登录密码在别的设备已经修改，请重新登录', '操作提示', {
                        confirmButtonText: '确定',
                        type: 'warning',
                        callback: () => {
                            window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL
                        }
                    })
                }
                break;
            default:
                console.log('default here')
                context.dispatch("base/showAlert", {
                    modalTitle: error.message,
                    modalHeader: error.response.data.error,
                    modalContent: error.response.data.message,
                }, {root: true});
                break;
        }
    }
};
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
